<script>
    import Header from '../global/header.svelte'
     import Loader from '../widgets/loader.svelte'
    import { onMount } from 'svelte';

    let events = [];
    let selectedArticle = "";
    let noEvents = "";
    let loading = true;

	onMount(async () => {
		const res = await fetch(`https://api.southernco-op.co.uk/events/get`);
        events = await res.json();
       
        if( events.ok ) {
            loading = false;
        } else {
            loading = false;
        }


	});

    function loadArticle( oArticle ) {
        selectedArticle = oArticle;
    }

    function closeArticle() {
        selectedArticle = "";
    }

</script>

<style>
    article {
        background: var(--dark-color);
        padding: 24px;
        position: relative;
        border-radius: 10px;
        margin-bottom: 1em;
    }
    article:after {
        content:'';
        width: 12px;
        height: 21px;
        background: url('../svg/angle-right.svg');
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 10px;
    }
    h2,h3 {
        font-weight: 500;
    }
    h2{
        margin:0 0 .25em 0;
    }
    h3 {
        font-size: 13px;
        font-size: 1.3rem;
        color: var(--brand-color);
        margin-bottom: 0;
    }
    .articlehead {
        font-size: 22px;
        font-weight: 500;
        line-height: 24px;
    }
    
</style>

<svelte:head>
    <title>Events Page</title>
</svelte:head>



{#if selectedArticle}
    <header class="header">
        <div>
            <a href="#close" on:click={closeArticle}>
                 <svg xmlns="http://www.w3.org/2000/svg" width="12.387" height="21.667" viewBox="0 0 12.387 21.667">
                    <path id="Icon_ionic-ios-arrow-back" data-name="Icon ionic-ios-arrow-back" d="M14.985,17.024l8.2-8.192A1.548,1.548,0,0,0,20.99,6.646L11.7,15.928a1.545,1.545,0,0,0-.045,2.135l9.327,9.346a1.548,1.548,0,1,0,2.193-2.187Z" transform="translate(-11.251 -6.194)" fill="#00627d"/>
                </svg>
            </a> 
            <h1>Events</h1>
        </div>
         <img src="svg/header-waves.svg" class="waves" alt="Waves" aria-hidden="true" />
    </header>
    <section>
        <h2 class="articlehead">{@html selectedArticle.title.rendered}</h2>
         <h3>{@html selectedArticle.location}</h3>
        <div>
            {@html selectedArticle.content.rendered}
        </div>
    </section>
{:else}
    <Header title="Events" url="/" /> 
    <section>
        <div>
            {#if !loading}
                {#if events.length }
                    {#each events as article}
                        <article on:click={loadArticle(article)}>
                            <h2>{@html article.title.rendered}</h2>
                            <h3>{@html article.location}</h3>   
                        </article>                      
                    {/each}
                {:else}
                
                     <h3 class="articlehead top">Due to Covid-19 we are not running member trips and events at the current time.</h3>
                    <p>In order to make member trips relevant and valuable for those attending, our trips are geographically targeted.</p>
                    <p>Members are invited to join events near to where they live to visit truly ‘local’ producers who supply our Local Flavours range. Members can meet producers who operate within their own community to see how products are made and understand the relationship they have with us. </p>
                    <p>We also work with other partner organisations such as Wildlife Trusts and Tuppenny Barn developing member education sessions on sustainable issues such as bees and beach cleans.</p>
                {/if}
            {:else}
                 <Loader msg="Loading event data" />
            {/if}
        </div>
    </section>
{/if}
